import {
  RegisterPolicyDto,
  PolicyResponse
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class PolicyApi {
  register(
    registerPolicyDto: RegisterPolicyDto,
    token: string,
    successCallback: (policyResponse: PolicyResponse[]) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/policy`;
    console.log(registerPolicyDto.policy);

    new ApiHelper().postDataSecureAsync(
      url,
      registerPolicyDto,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
